var SubscriptionUpsell = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this._onSubChanged);
  }
  async upgradeToSubscription(lineKey, quantity, selling_plan = null) {
    // Check if we're on the cart page
    const isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';

    // Find the line-item element and its pill-loader
    const lineItemElement = document.querySelector(`line-item input[data-line-key="${lineKey}"]`)?.closest('line-item');
    const pillLoader = lineItemElement?.querySelector('pill-loader');

    // Set loading state
    if (pillLoader) {
      pillLoader.setAttribute('aria-busy', 'true');
    }

    // Dispatch will-change event (following theme pattern)
    if (lineItemElement) {
      lineItemElement.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true }));
    }

    // Get cart drawer section ID for refreshing (only if not on cart page)
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToBundle = [];

    if (cartDrawer && !isCartPage) {
      // Try to extract section ID (same logic as extractSectionId function)
      let sectionElement = cartDrawer.classList.contains('shopify-section') ? cartDrawer : cartDrawer.closest('.shopify-section');

      if (sectionElement) {
        const sectionId = sectionElement.id.replace('shopify-section-', '');
        if (sectionId) {
          sectionsToBundle.push(sectionId);
        }
      }
    }

    const body = {
      id: lineKey,
      quantity: quantity,
    };

    // Always include selling_plan in the request to handle both adding and removing subscriptions
    // When selling_plan is null/undefined, set it to null to remove the subscription
    // When it has a value, use that value to add/change the subscription
    body.selling_plan = selling_plan !== null && selling_plan !== undefined ? selling_plan : null;

    if (sectionsToBundle.length > 0) {
      body.sections = sectionsToBundle.join(',');
    }

    return fetch(`${Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => Promise.reject(err));
        }
        return response.json();
      })
      .then(async (cart) => {
        // If on cart page, refresh the page
        if (isCartPage) {
          window.location.reload();
          return cart;
        }

        // If sections weren't included in response, fetch them separately
        if (sectionsToBundle.length > 0 && (!cart.sections || !cart.sections[sectionsToBundle[0]])) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            try {
              const sectionId = sectionsToBundle[0];
              const sectionResponse = await fetch(`${Shopify.routes.root}?section_id=${sectionId}`);
              const sectionHtml = await sectionResponse.text();
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sectionHtml;
              const sectionData = tempDiv.querySelector(`#shopify-section-${sectionId}`);

              if (sectionData && !cart.sections) {
                cart.sections = {};
              }
              if (sectionData && cart.sections) {
                cart.sections[sectionId] = sectionData.outerHTML;
              }
            } catch (error) {
              console.warn('Could not fetch cart drawer section:', error);
            }
          }
        }

        // Remove loading state on success
        if (pillLoader) {
          pillLoader.removeAttribute('aria-busy');
        }

        // Dispatch cart change event with sections for cart drawer refresh
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'line-item:change',
              cart: cart,
            },
          })
        );
        return cart;
      })
      .catch((error) => {
        // Remove loading state on error
        if (pillLoader) {
          pillLoader.removeAttribute('aria-busy');
        }

        // Dispatch error event (following theme pattern)
        if (lineItemElement) {
          lineItemElement.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
        }

        console.error('Error updating cart:', error);
        throw error;
      });
  }
  _onSubChanged(event) {
    const changePlanSelector = event.target.closest('[data-change-selling-plans]');

    if (changePlanSelector) {
      const subPanel = changePlanSelector.closest('[data-sub-panel]');
      this.upgradeToSubscription(
        subPanel.dataset.line,
        subPanel.dataset.quantity,
        changePlanSelector.value == 'onetime' ? null : changePlanSelector.value
      );
    }
  }
};
if (!window.customElements.get('subscription-upsell')) {
  window.customElements.define('subscription-upsell', SubscriptionUpsell);
}
